<template>
  <v-select
    v-model="value_"
    variant="outlined"
    :disabled="$loader.loading"
    :append-inner-icon="filter?.icon"
    :label="filter?.label"
    :items="filter?.items"
    hide-details
    :density="dense"
    color="orange lighten-2"
    @change="onInput"
    @update:model-value="(v: any) => filter.onUpdate && filter.onUpdate(v)"
  />
</template>

<script lang="ts">
import { type PropType } from 'vue'
import { defineComponent } from 'vue'

import type DensityProp from '@/types/vuetify/Density'
import { type FiltersProps } from '@/types/DataTable'

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object as PropType<FiltersProps>,
      required: true,
    },
    dense: {
      type: String as PropType<DensityProp>,
      default: 'default',
    },
  },
  emits: [ 'input' ],
  data() {
    return {
      value_: this.value,
    }
  },
  methods: {
    onInput(): void {
      this.$emit('input', this.value_)
    },
  },
})
</script>
